<template>
  <div class="container">
    <div class="row dado__head">
      <div class="col-12 col-lg-3">
        <div class="title">Pesticide Reference</div>
      </div>
      <div class="col-12 col-lg-9">
        <div class="row dado__separately">
          <div class="col-12 col-md-4">
            <label class="dado__label">Survey Language</label>
            <v-select
              :options="getLangOptions"
              :flags="true"
              :search="true"
              :value="lang"
              @input="lang = $event"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <v-sidebar />
      <div class="col-12 col-lg-10">
        <div class="row mb-3">
          <div class="col">
            <router-link to="/pesticides">
              <button
                class="btn"
                :class="{ 'btn-active': $route.path === '/pesticides' }"
              >
                Pesticides
              </button>
            </router-link>
          </div>
          <div class="col">
            <router-link to="/active_ingredients">
              <button
                class="btn"
                :class="{ 'btn-active': $route.path === '/active_ingredients' }"
              >
                Active Ingredients
              </button>
            </router-link>
          </div>
          <div class="col">
            <router-link to="/crops">
              <button
                class="btn"
                :class="{ 'btn-active': $route.path === '/crops' }"
              >
                Crops
              </button>
            </router-link>
          </div>
          <div class="col">
            <router-link to="/pests">
              <button
                class="btn"
                :class="{ 'btn-active': $route.path === '/pests' }"
              >
                Pests
              </button>
            </router-link>
          </div>
          <div class="col">
            <router-link to="/organs">
              <button
                class="btn"
                :class="{ 'btn-active': $route.path === '/organs' }"
              >
                Organ Systems
              </button>
            </router-link>
          </div>
        </div>
        <template v-if="$route.path === '/pesticides'">
          <div class="row dado__separately">
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Search</label>
              <div class="search">
                <input
                  type="text"
                  v-model="pesticides_name"
                  placeholder="Type here..."
                  class="search__field"
                />
                <span
                  class="form__del"
                  :class="{ 'd-block': pesticides_name }"
                  @click="pesticides_name = null"
                ></span>
                <button type="submit" class="search__btn"></button>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Country</label>
              <vue-select
                v-model="pesticides_country"
                :options="getCountriesOptions(true)"
              />
            </div>
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Sorting by</label>
              <vue-select v-model="pesticides_sort" :options="sortOptions" />
            </div>
          </div>
          <div class="dado__array">
            <div class="dado__bred">
              <table class="table">
                <thead class="table__thead">
                  <tr class="table__tr">
                    <th class="table__th">ID</th>
                    <th class="table__th">Name</th>
                    <th class="table__th">Countries</th>
                    <th class="table__th"></th>
                  </tr>
                </thead>
                <tbody class="table__tbody">
                  <tr
                    class="table__tr"
                    v-for="pesticide in pesticides"
                    v-bind:key="pesticide.id"
                  >
                    <td class="table__td col_id">{{ pesticide.id }}</td>
                    <td class="table__td">{{ pesticide.name[lang] }}</td>
                    <td class="table__td">
                      <ul>
                        <li
                          v-for="country in pesticide.countries"
                          class="text-muted"
                          v-bind:key="pesticide.id + '-' + country.id"
                        >
                          {{ country.name }}
                        </li>
                      </ul>
                    </td>
                    <td class="table__td col_manage">
                      <div class="table__set">
                        <div class="table__pick edit">
                          <div
                            @click="onShowEditModalPesticide(pesticide)"
                            class="table__pick cursor-pointer edit"
                            v-tooltip="'Edit'"
                          >
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.5548 7.38065C10.4067 7.38065 10.2866 7.50072 10.2866 7.64886V10.0303C10.2861 10.4745 9.92619 10.8345 9.48197 10.8349H1.95628C1.51206 10.8345 1.15218 10.4745 1.15165 10.0303V3.041C1.15218 2.59688 1.51206 2.23689 1.95628 2.23637H4.33769C4.48583 2.23637 4.6059 2.1163 4.6059 1.96816C4.6059 1.82012 4.48583 1.69995 4.33769 1.69995H1.95628C1.21598 1.70079 0.616073 2.3007 0.615234 3.041V10.0304C0.616073 10.7707 1.21598 11.3706 1.95628 11.3714H9.48197C10.2223 11.3706 10.8222 10.7707 10.823 10.0304V7.64886C10.823 7.50072 10.703 7.38065 10.5548 7.38065Z"
                                fill="white"
                                stroke="white"
                                stroke-width="0.4"
                              />
                              <path
                                d="M10.7174 1.00977C10.246 0.538411 9.48183 0.538411 9.01047 1.00977L4.22544 5.7948C4.19265 5.82759 4.16897 5.86824 4.15661 5.91287L3.52737 8.18459C3.50149 8.27773 3.52778 8.37747 3.59609 8.44588C3.66451 8.51419 3.76425 8.54049 3.85739 8.51471L6.1291 7.88537C6.17374 7.873 6.21439 7.84932 6.24718 7.81653L11.0321 3.0314C11.5027 2.55973 11.5027 1.79617 11.0321 1.3245L10.7174 1.00977ZM4.80985 5.96913L8.72603 2.05285L9.98902 3.31585L6.07274 7.23213L4.80985 5.96913ZM4.55756 6.47538L5.5666 7.48452L4.17086 7.87122L4.55756 6.47538ZM10.6528 2.65213L10.3684 2.93658L9.10529 1.67348L9.38984 1.38903C9.65166 1.12721 10.0762 1.12721 10.338 1.38903L10.6528 1.70376C10.9142 1.96589 10.9142 2.39011 10.6528 2.65213Z"
                                fill="white"
                                stroke="white"
                                stroke-width="0.4"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          @click="onDeletePesticide(pesticide)"
                          class="table__pick cursor-pointer delete"
                          v-tooltip="'Delete'"
                        >
                          <svg
                            class="table__icon"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.1447 3.10532C17.0745 3.03517 16.9846 2.99991 16.8753 2.99991H13.2541L12.4338 1.04299C12.3166 0.753857 12.1056 0.507743 11.8011 0.304605C11.4963 0.101508 11.1875 0 10.8751 0H7.12503C6.81262 0 6.50395 0.101508 6.19927 0.304605C5.89454 0.507743 5.6836 0.753816 5.56637 1.04299L4.74606 2.99991H1.12496C1.01549 2.99991 0.92576 3.03517 0.855407 3.10532C0.785259 3.17563 0.75 3.26552 0.75 3.37487V4.12495C0.75 4.2343 0.785095 4.32419 0.855407 4.39438C0.92576 4.46465 1.01565 4.49978 1.12496 4.49978H2.24987V15.6562C2.24987 16.3048 2.43347 16.8574 2.80063 17.3144C3.16787 17.7716 3.60929 18 4.12495 18H13.8752C14.391 18 14.8323 17.7637 15.1995 17.2912C15.5667 16.8183 15.7502 16.2579 15.7502 15.6095V4.49978H16.8753C16.9846 4.49978 17.0745 4.46465 17.1447 4.39438C17.2148 4.32423 17.2502 4.2343 17.2502 4.12495V3.37487C17.2502 3.26552 17.2148 3.17563 17.1447 3.10532ZM6.94931 1.62864C7.00394 1.55836 7.07039 1.51527 7.14851 1.49975H10.8634C10.9415 1.51539 11.008 1.55845 11.0626 1.62864L11.6253 2.99975H6.37507L6.94931 1.62864ZM14.2503 15.6095C14.2503 15.7814 14.223 15.9396 14.1682 16.0841C14.1135 16.2285 14.0567 16.334 13.9983 16.4004C13.9395 16.467 13.8988 16.5 13.8752 16.5H4.12499C4.10155 16.5 4.06075 16.467 4.00202 16.4004C3.94336 16.334 3.88668 16.2285 3.83196 16.0841C3.77733 15.9396 3.74999 15.7812 3.74999 15.6095V4.49978H14.2503V15.6095H14.2503Z"
                              fill="white"
                            />
                            <path
                              d="M5.62496 14.2501H6.37491C6.48438 14.2501 6.57432 14.215 6.64446 14.1447C6.71461 14.0742 6.74987 13.9846 6.74987 13.8751V7.12483C6.74987 7.01553 6.71461 6.92564 6.64446 6.85528C6.57411 6.78514 6.48443 6.75 6.37491 6.75H5.62496C5.51549 6.75 5.42572 6.78509 5.35541 6.85528C5.28518 6.92564 5.25 7.01553 5.25 7.12483V13.8751C5.25 13.9846 5.28505 14.0743 5.35541 14.1447C5.42572 14.215 5.51549 14.2501 5.62496 14.2501Z"
                              fill="white"
                            />
                            <path
                              d="M8.62496 14.2501H9.37492C9.48435 14.2501 9.57424 14.215 9.64435 14.1447C9.71486 14.0742 9.74979 13.9846 9.74979 13.8751V7.12483C9.74979 7.01553 9.71482 6.92564 9.64435 6.85528C9.57424 6.78514 9.48435 6.75 9.37492 6.75H8.62496C8.51561 6.75 8.42572 6.78509 8.35541 6.85528C8.28505 6.92564 8.25 7.01553 8.25 7.12483V13.8751C8.25 13.9846 8.28505 14.0743 8.35541 14.1447C8.42568 14.215 8.51561 14.2501 8.62496 14.2501Z"
                              fill="white"
                            />
                            <path
                              d="M11.625 14.2501H12.3749C12.4844 14.2501 12.5743 14.215 12.6445 14.1447C12.7148 14.0742 12.7497 13.9846 12.7497 13.8751V7.12483C12.7497 7.01553 12.7147 6.92564 12.6445 6.85528C12.5743 6.78514 12.4844 6.75 12.3749 6.75H11.625C11.5154 6.75 11.4258 6.78509 11.3553 6.85528C11.2851 6.92564 11.25 7.01553 11.25 7.12483V13.8751C11.25 13.9846 11.2851 14.0743 11.3553 14.1447C11.4258 14.215 11.5154 14.2501 11.625 14.2501Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="questions__box mt-4 mb-0 py-4">
            <div class="questions__topic">
              <div
                class="text-dark text-decoration-none cursor-pointer"
                @click="onShowCreateModalPesticide"
              >
                <span class="questions__add"></span>Add a Pesticide
              </div>
            </div>
          </div>
        </template>
        <template v-if="$route.path === '/active_ingredients'">
          <div class="row dado__separately">
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Search</label>
              <div class="search">
                <input
                  type="text"
                  v-model="ingredients_name"
                  placeholder="Type here..."
                  class="search__field"
                />
                <span
                  class="form__del"
                  :class="{ 'd-block': ingredients_name }"
                  @click="ingredients_name = null"
                ></span>
                <button type="submit" class="search__btn"></button>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Sorting by</label>
              <vue-select v-model="ingredients_sort" :options="sortOptions" />
            </div>
          </div>
          <div class="dado__array">
            <div class="dado__bred">
              <table class="table">
                <thead class="table__thead">
                  <tr class="table__tr">
                    <th class="table__th">ID</th>
                    <th class="table__th">Name</th>
                    <th class="table__th">Pesticides</th>
                    <th class="table__th"></th>
                  </tr>
                </thead>
                <tbody class="table__tbody">
                  <tr
                    class="table__tr"
                    v-for="active_ingredient in active_ingredients"
                    v-bind:key="active_ingredient.id"
                  >
                    <td class="table__td col_id">{{ active_ingredient.id }}</td>
                    <td class="table__td">{{ active_ingredient.name }}</td>
                    <td class="table__td">
                      <ul>
                        <li
                          v-for="pesticide in active_ingredient.pesticides"
                          v-bind:key="active_ingredient.id + '-' + pesticide.id"
                          class="text-muted"
                        >
                          {{ pesticide.name[lang] }}
                        </li>
                      </ul>
                    </td>
                    <td class="table__td col_manage">
                      <div class="table__set">
                        <div class="table__pick edit">
                          <div
                            @click="
                              onShowEditModalActiveIngredient(active_ingredient)
                            "
                            class="table__pick cursor-pointer edit"
                            v-tooltip="'Edit'"
                          >
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.5548 7.38065C10.4067 7.38065 10.2866 7.50072 10.2866 7.64886V10.0303C10.2861 10.4745 9.92619 10.8345 9.48197 10.8349H1.95628C1.51206 10.8345 1.15218 10.4745 1.15165 10.0303V3.041C1.15218 2.59688 1.51206 2.23689 1.95628 2.23637H4.33769C4.48583 2.23637 4.6059 2.1163 4.6059 1.96816C4.6059 1.82012 4.48583 1.69995 4.33769 1.69995H1.95628C1.21598 1.70079 0.616073 2.3007 0.615234 3.041V10.0304C0.616073 10.7707 1.21598 11.3706 1.95628 11.3714H9.48197C10.2223 11.3706 10.8222 10.7707 10.823 10.0304V7.64886C10.823 7.50072 10.703 7.38065 10.5548 7.38065Z"
                                fill="white"
                                stroke="white"
                                stroke-width="0.4"
                              />
                              <path
                                d="M10.7174 1.00977C10.246 0.538411 9.48183 0.538411 9.01047 1.00977L4.22544 5.7948C4.19265 5.82759 4.16897 5.86824 4.15661 5.91287L3.52737 8.18459C3.50149 8.27773 3.52778 8.37747 3.59609 8.44588C3.66451 8.51419 3.76425 8.54049 3.85739 8.51471L6.1291 7.88537C6.17374 7.873 6.21439 7.84932 6.24718 7.81653L11.0321 3.0314C11.5027 2.55973 11.5027 1.79617 11.0321 1.3245L10.7174 1.00977ZM4.80985 5.96913L8.72603 2.05285L9.98902 3.31585L6.07274 7.23213L4.80985 5.96913ZM4.55756 6.47538L5.5666 7.48452L4.17086 7.87122L4.55756 6.47538ZM10.6528 2.65213L10.3684 2.93658L9.10529 1.67348L9.38984 1.38903C9.65166 1.12721 10.0762 1.12721 10.338 1.38903L10.6528 1.70376C10.9142 1.96589 10.9142 2.39011 10.6528 2.65213Z"
                                fill="white"
                                stroke="white"
                                stroke-width="0.4"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          @click="onDeleteActiveIngredient(active_ingredient)"
                          class="table__pick cursor-pointer delete"
                          v-tooltip="'Delete'"
                        >
                          <svg
                            class="table__icon"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.1447 3.10532C17.0745 3.03517 16.9846 2.99991 16.8753 2.99991H13.2541L12.4338 1.04299C12.3166 0.753857 12.1056 0.507743 11.8011 0.304605C11.4963 0.101508 11.1875 0 10.8751 0H7.12503C6.81262 0 6.50395 0.101508 6.19927 0.304605C5.89454 0.507743 5.6836 0.753816 5.56637 1.04299L4.74606 2.99991H1.12496C1.01549 2.99991 0.92576 3.03517 0.855407 3.10532C0.785259 3.17563 0.75 3.26552 0.75 3.37487V4.12495C0.75 4.2343 0.785095 4.32419 0.855407 4.39438C0.92576 4.46465 1.01565 4.49978 1.12496 4.49978H2.24987V15.6562C2.24987 16.3048 2.43347 16.8574 2.80063 17.3144C3.16787 17.7716 3.60929 18 4.12495 18H13.8752C14.391 18 14.8323 17.7637 15.1995 17.2912C15.5667 16.8183 15.7502 16.2579 15.7502 15.6095V4.49978H16.8753C16.9846 4.49978 17.0745 4.46465 17.1447 4.39438C17.2148 4.32423 17.2502 4.2343 17.2502 4.12495V3.37487C17.2502 3.26552 17.2148 3.17563 17.1447 3.10532ZM6.94931 1.62864C7.00394 1.55836 7.07039 1.51527 7.14851 1.49975H10.8634C10.9415 1.51539 11.008 1.55845 11.0626 1.62864L11.6253 2.99975H6.37507L6.94931 1.62864ZM14.2503 15.6095C14.2503 15.7814 14.223 15.9396 14.1682 16.0841C14.1135 16.2285 14.0567 16.334 13.9983 16.4004C13.9395 16.467 13.8988 16.5 13.8752 16.5H4.12499C4.10155 16.5 4.06075 16.467 4.00202 16.4004C3.94336 16.334 3.88668 16.2285 3.83196 16.0841C3.77733 15.9396 3.74999 15.7812 3.74999 15.6095V4.49978H14.2503V15.6095H14.2503Z"
                              fill="white"
                            />
                            <path
                              d="M5.62496 14.2501H6.37491C6.48438 14.2501 6.57432 14.215 6.64446 14.1447C6.71461 14.0742 6.74987 13.9846 6.74987 13.8751V7.12483C6.74987 7.01553 6.71461 6.92564 6.64446 6.85528C6.57411 6.78514 6.48443 6.75 6.37491 6.75H5.62496C5.51549 6.75 5.42572 6.78509 5.35541 6.85528C5.28518 6.92564 5.25 7.01553 5.25 7.12483V13.8751C5.25 13.9846 5.28505 14.0743 5.35541 14.1447C5.42572 14.215 5.51549 14.2501 5.62496 14.2501Z"
                              fill="white"
                            />
                            <path
                              d="M8.62496 14.2501H9.37492C9.48435 14.2501 9.57424 14.215 9.64435 14.1447C9.71486 14.0742 9.74979 13.9846 9.74979 13.8751V7.12483C9.74979 7.01553 9.71482 6.92564 9.64435 6.85528C9.57424 6.78514 9.48435 6.75 9.37492 6.75H8.62496C8.51561 6.75 8.42572 6.78509 8.35541 6.85528C8.28505 6.92564 8.25 7.01553 8.25 7.12483V13.8751C8.25 13.9846 8.28505 14.0743 8.35541 14.1447C8.42568 14.215 8.51561 14.2501 8.62496 14.2501Z"
                              fill="white"
                            />
                            <path
                              d="M11.625 14.2501H12.3749C12.4844 14.2501 12.5743 14.215 12.6445 14.1447C12.7148 14.0742 12.7497 13.9846 12.7497 13.8751V7.12483C12.7497 7.01553 12.7147 6.92564 12.6445 6.85528C12.5743 6.78514 12.4844 6.75 12.3749 6.75H11.625C11.5154 6.75 11.4258 6.78509 11.3553 6.85528C11.2851 6.92564 11.25 7.01553 11.25 7.12483V13.8751C11.25 13.9846 11.2851 14.0743 11.3553 14.1447C11.4258 14.215 11.5154 14.2501 11.625 14.2501Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="questions__box mt-4 mb-0 py-4">
            <div class="questions__topic">
              <div
                class="text-dark text-decoration-none cursor-pointer"
                @click="onShowCreateModalActiveIngredient"
              >
                <span class="questions__add"></span>Add a Active Ingredient
              </div>
            </div>
          </div>
        </template>
        <template v-if="$route.path === '/crops'">
          <div class="row dado__separately">
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Search</label>
              <div class="search">
                <input
                  type="text"
                  v-model="crops_name"
                  placeholder="Type here..."
                  class="search__field"
                />
                <span
                  class="form__del"
                  :class="{ 'd-block': crops_name }"
                  @click="crops_name = null"
                ></span>
                <button type="submit" class="search__btn"></button>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Country</label>
              <vue-select
                v-model="crops_country"
                :options="getCountriesOptions(true)"
              />
            </div>
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Sorting by</label>
              <vue-select v-model="crops_sort" :options="sortOptions" />
            </div>
          </div>
          <div class="dado__array">
            <div class="dado__bred">
              <table class="table">
                <thead class="table__thead">
                  <tr class="table__tr">
                    <th class="table__th">ID</th>
                    <th class="table__th">Name</th>
                    <th class="table__th">Countries</th>
                    <th class="table__th"></th>
                  </tr>
                </thead>
                <tbody class="table__tbody">
                  <tr
                    class="table__tr"
                    v-for="scope in crops"
                    v-bind:key="scope.id"
                  >
                    <td class="table__td col_id">{{ scope.id }}</td>
                    <td class="table__td">{{ scope.name[lang] }}</td>
                    <td class="table__td">
                      <ul>
                        <li
                          v-for="country in scope.countries"
                          v-bind:key="scope.id + '-' + country.id"
                          class="text-muted"
                        >
                          {{ country.name }}
                        </li>
                      </ul>
                    </td>
                    <td class="table__td col_manage">
                      <div class="table__set">
                        <div class="table__pick edit">
                          <div
                            @click="onShowEditModalCrop(scope)"
                            class="table__pick cursor-pointer edit"
                            v-tooltip="'Edit'"
                          >
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.5548 7.38065C10.4067 7.38065 10.2866 7.50072 10.2866 7.64886V10.0303C10.2861 10.4745 9.92619 10.8345 9.48197 10.8349H1.95628C1.51206 10.8345 1.15218 10.4745 1.15165 10.0303V3.041C1.15218 2.59688 1.51206 2.23689 1.95628 2.23637H4.33769C4.48583 2.23637 4.6059 2.1163 4.6059 1.96816C4.6059 1.82012 4.48583 1.69995 4.33769 1.69995H1.95628C1.21598 1.70079 0.616073 2.3007 0.615234 3.041V10.0304C0.616073 10.7707 1.21598 11.3706 1.95628 11.3714H9.48197C10.2223 11.3706 10.8222 10.7707 10.823 10.0304V7.64886C10.823 7.50072 10.703 7.38065 10.5548 7.38065Z"
                                fill="white"
                                stroke="white"
                                stroke-width="0.4"
                              />
                              <path
                                d="M10.7174 1.00977C10.246 0.538411 9.48183 0.538411 9.01047 1.00977L4.22544 5.7948C4.19265 5.82759 4.16897 5.86824 4.15661 5.91287L3.52737 8.18459C3.50149 8.27773 3.52778 8.37747 3.59609 8.44588C3.66451 8.51419 3.76425 8.54049 3.85739 8.51471L6.1291 7.88537C6.17374 7.873 6.21439 7.84932 6.24718 7.81653L11.0321 3.0314C11.5027 2.55973 11.5027 1.79617 11.0321 1.3245L10.7174 1.00977ZM4.80985 5.96913L8.72603 2.05285L9.98902 3.31585L6.07274 7.23213L4.80985 5.96913ZM4.55756 6.47538L5.5666 7.48452L4.17086 7.87122L4.55756 6.47538ZM10.6528 2.65213L10.3684 2.93658L9.10529 1.67348L9.38984 1.38903C9.65166 1.12721 10.0762 1.12721 10.338 1.38903L10.6528 1.70376C10.9142 1.96589 10.9142 2.39011 10.6528 2.65213Z"
                                fill="white"
                                stroke="white"
                                stroke-width="0.4"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          @click="onDeleteCrop(scope)"
                          class="table__pick cursor-pointer delete"
                          v-tooltip="'Delete'"
                        >
                          <svg
                            class="table__icon"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.1447 3.10532C17.0745 3.03517 16.9846 2.99991 16.8753 2.99991H13.2541L12.4338 1.04299C12.3166 0.753857 12.1056 0.507743 11.8011 0.304605C11.4963 0.101508 11.1875 0 10.8751 0H7.12503C6.81262 0 6.50395 0.101508 6.19927 0.304605C5.89454 0.507743 5.6836 0.753816 5.56637 1.04299L4.74606 2.99991H1.12496C1.01549 2.99991 0.92576 3.03517 0.855407 3.10532C0.785259 3.17563 0.75 3.26552 0.75 3.37487V4.12495C0.75 4.2343 0.785095 4.32419 0.855407 4.39438C0.92576 4.46465 1.01565 4.49978 1.12496 4.49978H2.24987V15.6562C2.24987 16.3048 2.43347 16.8574 2.80063 17.3144C3.16787 17.7716 3.60929 18 4.12495 18H13.8752C14.391 18 14.8323 17.7637 15.1995 17.2912C15.5667 16.8183 15.7502 16.2579 15.7502 15.6095V4.49978H16.8753C16.9846 4.49978 17.0745 4.46465 17.1447 4.39438C17.2148 4.32423 17.2502 4.2343 17.2502 4.12495V3.37487C17.2502 3.26552 17.2148 3.17563 17.1447 3.10532ZM6.94931 1.62864C7.00394 1.55836 7.07039 1.51527 7.14851 1.49975H10.8634C10.9415 1.51539 11.008 1.55845 11.0626 1.62864L11.6253 2.99975H6.37507L6.94931 1.62864ZM14.2503 15.6095C14.2503 15.7814 14.223 15.9396 14.1682 16.0841C14.1135 16.2285 14.0567 16.334 13.9983 16.4004C13.9395 16.467 13.8988 16.5 13.8752 16.5H4.12499C4.10155 16.5 4.06075 16.467 4.00202 16.4004C3.94336 16.334 3.88668 16.2285 3.83196 16.0841C3.77733 15.9396 3.74999 15.7812 3.74999 15.6095V4.49978H14.2503V15.6095H14.2503Z"
                              fill="white"
                            />
                            <path
                              d="M5.62496 14.2501H6.37491C6.48438 14.2501 6.57432 14.215 6.64446 14.1447C6.71461 14.0742 6.74987 13.9846 6.74987 13.8751V7.12483C6.74987 7.01553 6.71461 6.92564 6.64446 6.85528C6.57411 6.78514 6.48443 6.75 6.37491 6.75H5.62496C5.51549 6.75 5.42572 6.78509 5.35541 6.85528C5.28518 6.92564 5.25 7.01553 5.25 7.12483V13.8751C5.25 13.9846 5.28505 14.0743 5.35541 14.1447C5.42572 14.215 5.51549 14.2501 5.62496 14.2501Z"
                              fill="white"
                            />
                            <path
                              d="M8.62496 14.2501H9.37492C9.48435 14.2501 9.57424 14.215 9.64435 14.1447C9.71486 14.0742 9.74979 13.9846 9.74979 13.8751V7.12483C9.74979 7.01553 9.71482 6.92564 9.64435 6.85528C9.57424 6.78514 9.48435 6.75 9.37492 6.75H8.62496C8.51561 6.75 8.42572 6.78509 8.35541 6.85528C8.28505 6.92564 8.25 7.01553 8.25 7.12483V13.8751C8.25 13.9846 8.28505 14.0743 8.35541 14.1447C8.42568 14.215 8.51561 14.2501 8.62496 14.2501Z"
                              fill="white"
                            />
                            <path
                              d="M11.625 14.2501H12.3749C12.4844 14.2501 12.5743 14.215 12.6445 14.1447C12.7148 14.0742 12.7497 13.9846 12.7497 13.8751V7.12483C12.7497 7.01553 12.7147 6.92564 12.6445 6.85528C12.5743 6.78514 12.4844 6.75 12.3749 6.75H11.625C11.5154 6.75 11.4258 6.78509 11.3553 6.85528C11.2851 6.92564 11.25 7.01553 11.25 7.12483V13.8751C11.25 13.9846 11.2851 14.0743 11.3553 14.1447C11.4258 14.215 11.5154 14.2501 11.625 14.2501Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="questions__box mt-4 mb-0 py-4">
            <div class="questions__topic">
              <div
                class="text-dark text-decoration-none cursor-pointer"
                @click="onShowCreateModalCrop"
              >
                <span class="questions__add"></span>Add a Crop
              </div>
            </div>
          </div>
        </template>
        <template v-if="$route.path === '/pests'">
          <div class="row dado__separately">
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Search</label>
              <div class="search">
                <input
                  type="text"
                  v-model="pests_name"
                  placeholder="Type here..."
                  class="search__field"
                />
                <span
                  class="form__del"
                  :class="{ 'd-block': pests_name }"
                  @click="pests_name = null"
                ></span>
                <button type="submit" class="search__btn"></button>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Country</label>
              <vue-select
                v-model="pests_country"
                :options="getCountriesOptions(true)"
              />
            </div>
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Sorting by</label>
              <vue-select v-model="pests_sort" :options="sortOptions" />
            </div>
          </div>
          <div class="dado__array">
            <div class="dado__bred">
              <table class="table">
                <thead class="table__thead">
                  <tr class="table__tr">
                    <th class="table__th">ID</th>
                    <th class="table__th">Name</th>
                    <th class="table__th">Countries</th>
                    <th class="table__th"></th>
                  </tr>
                </thead>
                <tbody class="table__tbody">
                  <tr
                    class="table__tr"
                    v-for="pest in pests"
                    v-bind:key="pest.id"
                  >
                    <td class="table__td col_id">{{ pest.id }}</td>
                    <td class="table__td">{{ pest.name[lang] }}</td>
                    <td class="table__td">
                      <ul>
                        <li
                          v-for="country in pest.countries"
                          v-bind:key="pest.id + '-' + country.id"
                          class="text-muted"
                        >
                          {{ country.name }}
                        </li>
                      </ul>
                    </td>
                    <td class="table__td col_manage">
                      <div class="table__set">
                        <div class="table__pick edit">
                          <div
                            @click="onShowEditModalPest(pest)"
                            class="table__pick cursor-pointer edit"
                            v-tooltip="'Edit'"
                          >
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.5548 7.38065C10.4067 7.38065 10.2866 7.50072 10.2866 7.64886V10.0303C10.2861 10.4745 9.92619 10.8345 9.48197 10.8349H1.95628C1.51206 10.8345 1.15218 10.4745 1.15165 10.0303V3.041C1.15218 2.59688 1.51206 2.23689 1.95628 2.23637H4.33769C4.48583 2.23637 4.6059 2.1163 4.6059 1.96816C4.6059 1.82012 4.48583 1.69995 4.33769 1.69995H1.95628C1.21598 1.70079 0.616073 2.3007 0.615234 3.041V10.0304C0.616073 10.7707 1.21598 11.3706 1.95628 11.3714H9.48197C10.2223 11.3706 10.8222 10.7707 10.823 10.0304V7.64886C10.823 7.50072 10.703 7.38065 10.5548 7.38065Z"
                                fill="white"
                                stroke="white"
                                stroke-width="0.4"
                              />
                              <path
                                d="M10.7174 1.00977C10.246 0.538411 9.48183 0.538411 9.01047 1.00977L4.22544 5.7948C4.19265 5.82759 4.16897 5.86824 4.15661 5.91287L3.52737 8.18459C3.50149 8.27773 3.52778 8.37747 3.59609 8.44588C3.66451 8.51419 3.76425 8.54049 3.85739 8.51471L6.1291 7.88537C6.17374 7.873 6.21439 7.84932 6.24718 7.81653L11.0321 3.0314C11.5027 2.55973 11.5027 1.79617 11.0321 1.3245L10.7174 1.00977ZM4.80985 5.96913L8.72603 2.05285L9.98902 3.31585L6.07274 7.23213L4.80985 5.96913ZM4.55756 6.47538L5.5666 7.48452L4.17086 7.87122L4.55756 6.47538ZM10.6528 2.65213L10.3684 2.93658L9.10529 1.67348L9.38984 1.38903C9.65166 1.12721 10.0762 1.12721 10.338 1.38903L10.6528 1.70376C10.9142 1.96589 10.9142 2.39011 10.6528 2.65213Z"
                                fill="white"
                                stroke="white"
                                stroke-width="0.4"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          @click="onDeletePest(pest)"
                          class="table__pick cursor-pointer delete"
                          v-tooltip="'Delete'"
                        >
                          <svg
                            class="table__icon"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.1447 3.10532C17.0745 3.03517 16.9846 2.99991 16.8753 2.99991H13.2541L12.4338 1.04299C12.3166 0.753857 12.1056 0.507743 11.8011 0.304605C11.4963 0.101508 11.1875 0 10.8751 0H7.12503C6.81262 0 6.50395 0.101508 6.19927 0.304605C5.89454 0.507743 5.6836 0.753816 5.56637 1.04299L4.74606 2.99991H1.12496C1.01549 2.99991 0.92576 3.03517 0.855407 3.10532C0.785259 3.17563 0.75 3.26552 0.75 3.37487V4.12495C0.75 4.2343 0.785095 4.32419 0.855407 4.39438C0.92576 4.46465 1.01565 4.49978 1.12496 4.49978H2.24987V15.6562C2.24987 16.3048 2.43347 16.8574 2.80063 17.3144C3.16787 17.7716 3.60929 18 4.12495 18H13.8752C14.391 18 14.8323 17.7637 15.1995 17.2912C15.5667 16.8183 15.7502 16.2579 15.7502 15.6095V4.49978H16.8753C16.9846 4.49978 17.0745 4.46465 17.1447 4.39438C17.2148 4.32423 17.2502 4.2343 17.2502 4.12495V3.37487C17.2502 3.26552 17.2148 3.17563 17.1447 3.10532ZM6.94931 1.62864C7.00394 1.55836 7.07039 1.51527 7.14851 1.49975H10.8634C10.9415 1.51539 11.008 1.55845 11.0626 1.62864L11.6253 2.99975H6.37507L6.94931 1.62864ZM14.2503 15.6095C14.2503 15.7814 14.223 15.9396 14.1682 16.0841C14.1135 16.2285 14.0567 16.334 13.9983 16.4004C13.9395 16.467 13.8988 16.5 13.8752 16.5H4.12499C4.10155 16.5 4.06075 16.467 4.00202 16.4004C3.94336 16.334 3.88668 16.2285 3.83196 16.0841C3.77733 15.9396 3.74999 15.7812 3.74999 15.6095V4.49978H14.2503V15.6095H14.2503Z"
                              fill="white"
                            />
                            <path
                              d="M5.62496 14.2501H6.37491C6.48438 14.2501 6.57432 14.215 6.64446 14.1447C6.71461 14.0742 6.74987 13.9846 6.74987 13.8751V7.12483C6.74987 7.01553 6.71461 6.92564 6.64446 6.85528C6.57411 6.78514 6.48443 6.75 6.37491 6.75H5.62496C5.51549 6.75 5.42572 6.78509 5.35541 6.85528C5.28518 6.92564 5.25 7.01553 5.25 7.12483V13.8751C5.25 13.9846 5.28505 14.0743 5.35541 14.1447C5.42572 14.215 5.51549 14.2501 5.62496 14.2501Z"
                              fill="white"
                            />
                            <path
                              d="M8.62496 14.2501H9.37492C9.48435 14.2501 9.57424 14.215 9.64435 14.1447C9.71486 14.0742 9.74979 13.9846 9.74979 13.8751V7.12483C9.74979 7.01553 9.71482 6.92564 9.64435 6.85528C9.57424 6.78514 9.48435 6.75 9.37492 6.75H8.62496C8.51561 6.75 8.42572 6.78509 8.35541 6.85528C8.28505 6.92564 8.25 7.01553 8.25 7.12483V13.8751C8.25 13.9846 8.28505 14.0743 8.35541 14.1447C8.42568 14.215 8.51561 14.2501 8.62496 14.2501Z"
                              fill="white"
                            />
                            <path
                              d="M11.625 14.2501H12.3749C12.4844 14.2501 12.5743 14.215 12.6445 14.1447C12.7148 14.0742 12.7497 13.9846 12.7497 13.8751V7.12483C12.7497 7.01553 12.7147 6.92564 12.6445 6.85528C12.5743 6.78514 12.4844 6.75 12.3749 6.75H11.625C11.5154 6.75 11.4258 6.78509 11.3553 6.85528C11.2851 6.92564 11.25 7.01553 11.25 7.12483V13.8751C11.25 13.9846 11.2851 14.0743 11.3553 14.1447C11.4258 14.215 11.5154 14.2501 11.625 14.2501Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="questions__box mt-4 mb-0 py-4">
            <div class="questions__topic">
              <div
                class="text-dark text-decoration-none cursor-pointer"
                @click="onShowCreateModalPest"
              >
                <span class="questions__add"></span>Add a Pest
              </div>
            </div>
          </div>
        </template>
        <template v-if="$route.path === '/organs'">
          <div class="row dado__separately">
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Search</label>
              <div class="search">
                <input
                  type="text"
                  v-model="organs_name"
                  placeholder="Type here..."
                  class="search__field"
                />
                <span
                  class="form__del"
                  :class="{ 'd-block': organs_name }"
                  @click="organs_name = null"
                ></span>
                <button type="submit" class="search__btn"></button>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <label class="dado__label">Sorting by</label>
              <vue-select v-model="organs_sort" :options="sortOptions" />
            </div>
          </div>
          <div class="dado__array">
            <div class="dado__bred">
              <table class="table">
                <thead class="table__thead">
                  <tr class="table__tr">
                    <th class="table__th">ID</th>
                    <th class="table__th">Name</th>
                    <th class="table__th">Description</th>
                    <th class="table__th">Symptoms</th>
                    <th class="table__th"></th>
                  </tr>
                </thead>
                <tbody class="table__tbody">
                  <tr
                    class="table__tr"
                    v-for="system in organs"
                    v-bind:key="system.id"
                  >
                    <td class="table__td col_id">{{ system.id }}</td>
                    <td class="table__td">{{ system.name[lang] }}</td>
                    <td class="table__td">{{ system.description[lang] }}</td>
                    <td
                      class="table__td"
                      v-html="symptoms(system.symptoms)"
                    ></td>
                    <td class="table__td col_manage">
                      <div class="table__set">
                        <div class="table__pick edit">
                          <div
                            @click="onShowEditModalOrganSystem(system)"
                            class="table__pick cursor-pointer edit"
                            v-tooltip="'Edit'"
                          >
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.5548 7.38065C10.4067 7.38065 10.2866 7.50072 10.2866 7.64886V10.0303C10.2861 10.4745 9.92619 10.8345 9.48197 10.8349H1.95628C1.51206 10.8345 1.15218 10.4745 1.15165 10.0303V3.041C1.15218 2.59688 1.51206 2.23689 1.95628 2.23637H4.33769C4.48583 2.23637 4.6059 2.1163 4.6059 1.96816C4.6059 1.82012 4.48583 1.69995 4.33769 1.69995H1.95628C1.21598 1.70079 0.616073 2.3007 0.615234 3.041V10.0304C0.616073 10.7707 1.21598 11.3706 1.95628 11.3714H9.48197C10.2223 11.3706 10.8222 10.7707 10.823 10.0304V7.64886C10.823 7.50072 10.703 7.38065 10.5548 7.38065Z"
                                fill="white"
                                stroke="white"
                                stroke-width="0.4"
                              />
                              <path
                                d="M10.7174 1.00977C10.246 0.538411 9.48183 0.538411 9.01047 1.00977L4.22544 5.7948C4.19265 5.82759 4.16897 5.86824 4.15661 5.91287L3.52737 8.18459C3.50149 8.27773 3.52778 8.37747 3.59609 8.44588C3.66451 8.51419 3.76425 8.54049 3.85739 8.51471L6.1291 7.88537C6.17374 7.873 6.21439 7.84932 6.24718 7.81653L11.0321 3.0314C11.5027 2.55973 11.5027 1.79617 11.0321 1.3245L10.7174 1.00977ZM4.80985 5.96913L8.72603 2.05285L9.98902 3.31585L6.07274 7.23213L4.80985 5.96913ZM4.55756 6.47538L5.5666 7.48452L4.17086 7.87122L4.55756 6.47538ZM10.6528 2.65213L10.3684 2.93658L9.10529 1.67348L9.38984 1.38903C9.65166 1.12721 10.0762 1.12721 10.338 1.38903L10.6528 1.70376C10.9142 1.96589 10.9142 2.39011 10.6528 2.65213Z"
                                fill="white"
                                stroke="white"
                                stroke-width="0.4"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          @click="onDeleteOrganSystem(system)"
                          class="table__pick cursor-pointer delete"
                          v-tooltip="'Delete'"
                        >
                          <svg
                            class="table__icon"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.1447 3.10532C17.0745 3.03517 16.9846 2.99991 16.8753 2.99991H13.2541L12.4338 1.04299C12.3166 0.753857 12.1056 0.507743 11.8011 0.304605C11.4963 0.101508 11.1875 0 10.8751 0H7.12503C6.81262 0 6.50395 0.101508 6.19927 0.304605C5.89454 0.507743 5.6836 0.753816 5.56637 1.04299L4.74606 2.99991H1.12496C1.01549 2.99991 0.92576 3.03517 0.855407 3.10532C0.785259 3.17563 0.75 3.26552 0.75 3.37487V4.12495C0.75 4.2343 0.785095 4.32419 0.855407 4.39438C0.92576 4.46465 1.01565 4.49978 1.12496 4.49978H2.24987V15.6562C2.24987 16.3048 2.43347 16.8574 2.80063 17.3144C3.16787 17.7716 3.60929 18 4.12495 18H13.8752C14.391 18 14.8323 17.7637 15.1995 17.2912C15.5667 16.8183 15.7502 16.2579 15.7502 15.6095V4.49978H16.8753C16.9846 4.49978 17.0745 4.46465 17.1447 4.39438C17.2148 4.32423 17.2502 4.2343 17.2502 4.12495V3.37487C17.2502 3.26552 17.2148 3.17563 17.1447 3.10532ZM6.94931 1.62864C7.00394 1.55836 7.07039 1.51527 7.14851 1.49975H10.8634C10.9415 1.51539 11.008 1.55845 11.0626 1.62864L11.6253 2.99975H6.37507L6.94931 1.62864ZM14.2503 15.6095C14.2503 15.7814 14.223 15.9396 14.1682 16.0841C14.1135 16.2285 14.0567 16.334 13.9983 16.4004C13.9395 16.467 13.8988 16.5 13.8752 16.5H4.12499C4.10155 16.5 4.06075 16.467 4.00202 16.4004C3.94336 16.334 3.88668 16.2285 3.83196 16.0841C3.77733 15.9396 3.74999 15.7812 3.74999 15.6095V4.49978H14.2503V15.6095H14.2503Z"
                              fill="white"
                            />
                            <path
                              d="M5.62496 14.2501H6.37491C6.48438 14.2501 6.57432 14.215 6.64446 14.1447C6.71461 14.0742 6.74987 13.9846 6.74987 13.8751V7.12483C6.74987 7.01553 6.71461 6.92564 6.64446 6.85528C6.57411 6.78514 6.48443 6.75 6.37491 6.75H5.62496C5.51549 6.75 5.42572 6.78509 5.35541 6.85528C5.28518 6.92564 5.25 7.01553 5.25 7.12483V13.8751C5.25 13.9846 5.28505 14.0743 5.35541 14.1447C5.42572 14.215 5.51549 14.2501 5.62496 14.2501Z"
                              fill="white"
                            />
                            <path
                              d="M8.62496 14.2501H9.37492C9.48435 14.2501 9.57424 14.215 9.64435 14.1447C9.71486 14.0742 9.74979 13.9846 9.74979 13.8751V7.12483C9.74979 7.01553 9.71482 6.92564 9.64435 6.85528C9.57424 6.78514 9.48435 6.75 9.37492 6.75H8.62496C8.51561 6.75 8.42572 6.78509 8.35541 6.85528C8.28505 6.92564 8.25 7.01553 8.25 7.12483V13.8751C8.25 13.9846 8.28505 14.0743 8.35541 14.1447C8.42568 14.215 8.51561 14.2501 8.62496 14.2501Z"
                              fill="white"
                            />
                            <path
                              d="M11.625 14.2501H12.3749C12.4844 14.2501 12.5743 14.215 12.6445 14.1447C12.7148 14.0742 12.7497 13.9846 12.7497 13.8751V7.12483C12.7497 7.01553 12.7147 6.92564 12.6445 6.85528C12.5743 6.78514 12.4844 6.75 12.3749 6.75H11.625C11.5154 6.75 11.4258 6.78509 11.3553 6.85528C11.2851 6.92564 11.25 7.01553 11.25 7.12483V13.8751C11.25 13.9846 11.2851 14.0743 11.3553 14.1447C11.4258 14.215 11.5154 14.2501 11.625 14.2501Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="questions__box mt-4 mb-0 py-4">
            <div class="questions__topic">
              <div
                class="text-dark text-decoration-none cursor-pointer"
                @click="onShowCreateModalOrganSystem"
              >
                <span class="questions__add"></span>Add a Organ System
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Dictionaries",
  data() {
    return {
      lang: "en",
      sortOptions: [
        { id: "asc", text: "Name ascending" },
        { id: "desc", text: "Name descending" },
      ],

      pesticides_name: null,
      pesticides_country: 0,
      pesticides_sort: "asc",

      ingredients_name: null,
      ingredients_sort: "asc",

      crops_name: null,
      crops_country: 0,
      crops_sort: "asc",

      pests_name: null,
      pests_country: 0,
      pests_sort: "asc",

      organs_name: null,
      organs_sort: "asc",
    };
  },
  computed: {
    ...mapGetters([
      "getLangOptions",
      "getCountriesOptions",
      "getPesticides",
      "getActiveIngredients",
      "getCrops",
      "getPests",
      "getOrganSystems",
    ]),
    pesticides() {
      let data = this.getPesticides;
      let self = this;

      if (this.pesticides_sort === "asc")
        data = _.sortBy(data, (item) => item.name);
      else data = _.sortBy(data, (item) => item.name).reverse();

      if (this.pesticides_name) {
        data = _.filter(data, function(item) {
          return (
            item.name[self.lang]
              .toLowerCase()
              .indexOf(self.pesticides_name.toLowerCase()) >= 0
          );
        });
      }

      if (this.pesticides_country != 0) {
        data = _.filter(data, function(item) {
          for (let country of item.countries)
            if (country.id == self.pesticides_country) return true;
          return false;
        });
      }

      return data;
    },
    active_ingredients() {
      let data = this.getActiveIngredients;
      let self = this;

      if (this.ingredients_sort === "asc")
        data = _.sortBy(data, (item) => item.name);
      else data = _.sortBy(data, (item) => item.name).reverse();

      if (this.ingredients_name) {
        data = _.filter(data, function(item) {
          let result = false;
          if (
            item.name
              .toLowerCase()
              .indexOf(self.ingredients_name.toLowerCase()) >= 0
          ) {
            result = true;
          } else {
            item.pesticides.forEach((value) => {
              if (value.name[self.lang]) {
                if (
                  value.name[self.lang]
                    .toLowerCase()
                    .indexOf(self.ingredients_name.toLowerCase()) >= 0
                ) {
                  result = true;
                }
              }
            });
          }
          return result;
        });
      }
      return data;
    },
    crops() {
      let data = this.getCrops;
      let self = this;

      if (this.crops_sort === "asc")
        data = _.sortBy(data, (item) => item.name[this.lang]);
      else data = _.sortBy(data, (item) => item.name[this.lang]).reverse();

      if (this.crops_name) {
        data = _.filter(data, function(item) {
          return item.name[self.lang]
            ? item.name[self.lang]
                .toLowerCase()
                .indexOf(self.crops_name.toLowerCase()) >= 0
            : false;
        });
      }

      if (this.crops_country != 0) {
        data = _.filter(data, function(item) {
          for (let country of item.countries)
            if (country.id == self.crops_country) return true;
          return false;
        });
      }

      return data;
    },
    pests() {
      let data = this.getPests;
      let self = this;

      if (this.pests_sort === "asc")
        data = _.sortBy(data, (item) => item.name[this.lang]);
      else data = _.sortBy(data, (item) => item.name[this.lang]).reverse();

      if (this.pests_name) {
        data = _.filter(data, function(item) {
          return item.name[self.lang]
            ? item.name[self.lang]
                .toLowerCase()
                .indexOf(self.pests_name.toLowerCase()) >= 0
            : false;
        });
      }

      if (this.pests_country != 0) {
        data = _.filter(data, function(item) {
          for (let country of item.countries)
            if (country.id == self.pests_country) return true;
          return false;
        });
      }

      return data;
    },
    organs() {
      let data = this.getOrganSystems;
      let self = this;

      if (this.organs_sort === "asc")
        data = _.sortBy(data, (item) => item.name[this.lang]);
      else data = _.sortBy(data, (item) => item.name[this.lang]).reverse();

      if (this.organs_name) {
        data = _.filter(data, function(item) {
          return item.name[self.lang]
            ? item.name[self.lang]
                .toLowerCase()
                .indexOf(self.organs_name.toLowerCase()) >= 0
            : false;
        });
      }

      return data;
    },
  },
  mounted() {
    this.queryCountries();
    this.queryPesticides();
    this.queryActiveIngredients();
    this.queryCrops();
    this.queryPests();
    this.queryOrganSystems();
  },
  methods: {
    ...mapActions([
      "showModal",
      "queryCountries",

      "queryPesticides",
      "destroyPesticide",

      "queryActiveIngredients",
      "destroyActiveIngredient",

      "queryCrops",
      "destroyCrop",

      "queryPests",
      "destroyPest",

      "queryOrganSystems",
      "destroyOrganSystem",
    ]),
    onShowCreateModalPesticide() {
      this.showModal({ modal: "ModalPesticide", data: {} });
    },
    onShowEditModalPesticide(pesticide) {
      let countries = [];
      for (let country of pesticide.countries) countries.push(country.id);

      this.showModal({
        modal: "ModalPesticide",
        data: {
          id: pesticide.id,
          name: pesticide.name,
          countries_id: countries,
        },
      });
    },
    onDeletePesticide(pesticide) {
      this.$confirm({
        message: "Delete pesticide " + pesticide.name + "?",
        callback: (confirm) => {
          if (confirm) this.destroyPesticide(pesticide.id);
        },
      });
    },

    onShowCreateModalActiveIngredient() {
      this.showModal({ modal: "ModalActiveIngredient", data: {} });
    },
    onShowEditModalActiveIngredient(active_ingredient) {
      let pesticides = [];
      for (let pesticide of active_ingredient.pesticides)
        pesticides.push(pesticide.id);
      this.showModal({
        modal: "ModalActiveIngredient",
        data: {
          id: active_ingredient.id,
          name: active_ingredient.name,
          pesticides_id: pesticides,
        },
      });
    },
    onDeleteActiveIngredient(active_ingredient) {
      this.$confirm({
        message: "Delete active ingredient " + active_ingredient.name + "?",
        callback: (confirm) => {
          if (confirm) this.destroyActiveIngredient(active_ingredient.id);
        },
      });
    },

    onShowCreateModalCrop() {
      this.showModal({ modal: "ModalCrop", data: {} });
    },
    onShowEditModalCrop(crop) {
      let countries = [];
      for (let country of crop.countries) countries.push(country.id);
      this.showModal({
        modal: "ModalCrop",
        data: { id: crop.id, name: crop.name, countries_id: countries },
      });
    },
    onDeleteCrop(crop) {
      this.$confirm({
        message: "Delete crop " + crop.name[this.lang] + "?",
        callback: (confirm) => {
          if (confirm) this.destroyCrop(crop.id);
        },
      });
    },

    onShowCreateModalPest() {
      this.showModal({ modal: "ModalPest", data: {} });
    },
    onShowEditModalPest(pest) {
      let countries = [];
      for (let country of pest.countries) countries.push(country.id);
      this.showModal({
        modal: "ModalPest",
        data: { id: pest.id, name: pest.name, countries_id: countries },
      });
    },
    onDeletePest(pest) {
      this.$confirm({
        message: "Delete pest " + pest.name[this.lang] + "?",
        callback: (confirm) => {
          if (confirm) this.destroyPest(pest.id);
        },
      });
    },

    onShowCreateModalOrganSystem() {
      this.showModal({ modal: "ModalOrganSystem", data: {} });
    },
    onShowEditModalOrganSystem(system) {
      this.showModal({
        modal: "ModalOrganSystem",
        data: {
          id: system.id,
          name: system.name,
          symptoms: system.symptoms,
          description: system.description,
        },
      });
    },
    onDeleteOrganSystem(system) {
      this.$confirm({
        message: "Delete organ system " + system.name[this.lang] + "?",
        callback: (confirm) => {
          if (confirm) this.destroyOrganSystem(system.id);
        },
      });
    },
    symptoms(data) {
      if (data && data[this.lang] != undefined) {
        return data[this.lang].join("<br>");
      }
      return "";
    },
  },
};
</script>

<style scoped>
.btn-active {
  background: #fff !important;
  color: #39833c !important;
}
</style>
